import { TextField } from '../../forms/FormikFields';
import { isPositiveNumber, isCorrectLength } from '../../forms/utils';
import { showNumbersOnly } from '../../../numeral';
import { REQUIRED_STUDENT_VALUES, FIELD_ZIP } from '../constants';
import styles from '../../../../sass/registration.module.scss';
function SchoolZipFilter(_ref) {
  var disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['input-sub']
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Filter by School Zip (used for school search)",
    placeholder: "Enter zip code for school",
    description: "If multiple schools are listed after you enter your school name, use this field to find your school by zip code.",
    maxLength: "5",
    validate: function validate(value) {
      return isPositiveNumber(value) || isCorrectLength(value, 5);
    },
    format: function format(val) {
      return showNumbersOnly(val);
    },
    name: FIELD_ZIP,
    required: REQUIRED_STUDENT_VALUES[FIELD_ZIP],
    disabled: disabled
  }));
}
export default SchoolZipFilter;